import { AxiosRequestConfig, AxiosResponse } from 'axios'
import http from 'shared/http/http'

export type UseAxiosRequestCfg = {
  url: string
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE'
}

type RequestProps<T extends Record<string, any>> = {
  input?: T
  options?: AxiosRequestConfig<T>
}

export const useAxios = <ResponseData>({ url, method = 'GET' }: UseAxiosRequestCfg) => {
  const request = async <Body>(
    args: RequestProps<Body> = {}
  ): Promise<AxiosResponse<ResponseData>> => {
    const { input } = args

    return http.request({ url, method: method ?? 'GET', data: input, ...args.options })
  }

  return { request }
}
